import { render, staticRenderFns } from "./previewBox.vue?vue&type=template&id=fd74a58c&scoped=true"
import script from "./previewBox.vue?vue&type=script&lang=js"
export * from "./previewBox.vue?vue&type=script&lang=js"
import style0 from "./previewBox.vue?vue&type=style&index=0&id=fd74a58c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd74a58c",
  null
  
)

export default component.exports